import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PDFObject from 'pdfobject';

import ErrorBoundary from '../../ErrorBoundary';

const FileViewPDFv3 = ({ file }) => {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    setContainer(document.getElementById('pdf-viewer'));
  }, []);

  useEffect(() => {
    if (container) {
      PDFObject.embed(file.urls.preview, '#pdf-viewer', {
        forcePDFJS: true,
        PDFJS_URL: '/pdfjs/web/viewer.html',
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [container, file.uuid]);

  return (
    <ErrorBoundary>
      <div id="pdf-viewer" style={{ height: '100%' }} />
    </ErrorBoundary>
  );
};

FileViewPDFv3.propTypes = {
  file: PropTypes.object.isRequired,
};

export default connect()(FileViewPDFv3);
